module.exports = __webpack_public_path__ + "static/media/educationslider.d214921a.jpg";